import Table from 'antd/es/table';
import styled from 'styled-components';

export const RiskLevel = styled.div`
	width: 127px;
	height: 32px;
	display: flex;
	padding: 8px;
	text-align: center;
	align-items: center;
	border-radius: 4px;
	justify-content: center;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	margin: 0 auto;
`;

export const TaskHeader = styled.div`
	background: ${({ theme }) => theme.colors.primary};
	color: ${({ theme }) => theme.palette.secondary.white};
	padding: 12px 24px;
	border-radius: 8px 8px 0 0;
	text-align: center;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};

	position: relative;
	margin-bottom: 0;
	width: 100%;
	height: 56px;
`;

export const TaskTitle = styled.p`
	font-size: ${({ theme }) => theme.sizes.fonts.fs_2xl};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
`;

export const StyledTable = styled(Table)`
	.ant-table-thead > tr > th {
		gap: 10px;
		height: 56px;
		padding: 8px;
		text-align: center;
		align-items: center;
		justify-content: center;
		border-bottom: 1px solid ${({ theme }) => theme.palette.secondary.white};
		font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_lg};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
		background-color: ${({ theme }) => theme.palette.secondary[100]} !important;

		&::before {
			display: none !important;
		}
	}
	.ant-table-cell {
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
		line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
		letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
		font-weight: ${({ theme }) => theme.sizes.weights.regular};
		text-align: center;
	}

	.ant-table-thead > tr > th:not(:last-child) {
		border: 1px solid ${({ theme }) => theme.palette.secondary.white};
	}

	.hidden-xs {
		@media (max-width: 1400px) {
			display: none !important;
		}
	}

	.visible-xs {
		display: none;
		@media (max-width: 1400px) {
			display: block !important;
		}
	}
`;

export const CreateButton = styled.button`
	width: 149px;
	height: 32px;
	font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_md};
	font-weight: ${({ theme }) => theme.sizes.weights.regular};
	border-radius: ${({ theme }) => theme.border.border_radius.br_sm};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	background-color: ${({ theme }) => theme.palette.secondary.white};
	padding: 8px;
	cursor: pointer;
	transition: all 0.2s ease;

	&:hover {
		background-color: #f5f5f5;
		border-color: ${({ theme }) => theme.palette.secondary[200]};
	}

	&:active {
		background-color: ${({ theme }) => theme.palette.secondary[150]};
	}
`;
